<template>
  <form-section :title="title">
    <template slot="controls">
      <content-actions
        v-model="value"
        :channel="$route.query.channel"
        :is-content-empty="isContentEmpty"
        import-enabled
        export-enabled
        apply-template-enabled
        copy-enabled
        :model="model"
      />
      <slot name="selected-template-info"></slot>
    </template>
    <el-row>
      <el-col :lg="10" :xl="8">
        <mobile-push-form
          :model="model"
          :value="value"
          os-type="android"
          @set-actions="setActions"
        />
      </el-col>

      <!-- Preview -->
      <el-col :lg="14" :xl="16" class="preview">
        <push-preview-section
          :app-icon="appIcon"
          :app-name="appName"
          :title="value.push_title"
          :text="previewPushText"
          :icon="value.push_picture"
          :actions="actions"
          platform="android"
          :new-frame="true"
        />
      </el-col>
    </el-row>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import PushPreviewSection from '@/common/components/push/PushPreviewSection'
import { channelTypes } from '@/modules/campaign-manage/enum/Labels'
import MobilePushForm from '@/modules/campaign-manage/components/content/channels/MobilePushForm'
import Icon from '@/img/icon/app-ico.png'
import ContentActions from '@/modules/campaign-manage/components/ContentActions'
import { voucherPositions } from '@/modules/campaign-manage/enum/VoucherPositionsEnum'

export default {
  name: 'AndroidPush',

  components: {
    ContentActions,
    MobilePushForm,
    FormSection,
    PushPreviewSection
  },

  props: {
    value: {
      required: true
    },
    title: {
      required: true
    },
    model: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      channelTypes,
      voucherPositions,
      actions: []
    }
  },

  mounted() {},

  computed: {
    isContentEmpty() {
      return !this.value.push_title && !this.value.push_text
    },

    appName() {
      return this.$store.state.app.project.name
    },

    appIcon() {
      return this.$store.state.app.project.icon || Icon
    },

    key() {
      return `${this.$route.query.channel}_${this.$route.query.variant}_${this.$route.query.lang}`
    },
    previewPushText() {
      let text = this.value.push_text
      if (this.model.voucher_codes_enabled && this.value.voucher_code_enabled) {
        if (this.value.voucher_code_position === voucherPositions.TOP) {
          text = this.$t('CampaignForm_VoucherCode_Sample') + '\n' + text
        } else {
          text = text + '\n' + this.$t('CampaignForm_VoucherCode_Sample')
        }
      }
      return text
    }
  },
  methods: {
    setActions(actions) {
      this.actions = actions
    }
  }
}
</script>

<style scoped>
.preview {
  background-color: #f8fafc;
  padding-top: 30px;
  padding-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/content/channels/AndroidPush.vue